import { getAllWxUsers } from '@/apis/user';
import { useCallback, useMemo } from 'react';
import { useRequest } from 'umi';

const useWxUserModel = () => {
  const {
    loading,
    data = [],
    run: getAllUsers,
  } = useRequest(getAllWxUsers, {
    formatResult: (res) => res.users,
    manual: true,
    refreshDeps: [],
    throwOnError: true,
  });

  const wxUsersMap = useMemo(() => {
    return data.reduce(
      (a, u) => ({
        ...a,
        [u.name]: u.fullName,
      }),
      {} as { [key in string]: string },
    );
  }, [data]);

  const handleGetUser = useCallback(() => {
    getAllUsers();
  }, [getAllUsers]);

  return {
    loading,
    wxUsersMap,
    users: data,
    getAllUsers: handleGetUser,
  };
};

export default useWxUserModel;
